// extracted by mini-css-extract-plugin
module.exports = {"container":"Watchlist_container__MWIr_","watchList":"Watchlist_watchList__2nWjE"};